module.exports = __webpack_public_path__ + "img/3.64f8fd6d.jpg";